// extracted by mini-css-extract-plugin
export default {"container":"friendsBar_container__Bdivq"};